import React, { useRef } from "react";
import { CircularProgress } from "@mui/material";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { ACCEPTED_IMAGE_TYPES } from "../lib/imageValidation";
import styles from "./CranialSteps.module.css";

const INSTRUCTIONS = [
  "Fotografe de cima, com a câmera diretamente acima da cabeça.",
  "Mantenha o celular paralelo à cabeça, sem inclinar.",
  "Enquadre a cabeça inteira, com uma margem ao redor.",
  "Deixe o nariz e as duas orelhas visíveis, com o nariz apontando para o topo da foto.",
  "Prenda o cabelo ou use uma touca fina para mostrar o contorno.",
  "Prefira um fundo neutro e boa iluminação, sem sombras fortes.",
  "Opcional: um marcador de tamanho conhecido na altura da cabeça permite medidas em milímetros.",
];

/**
 * First step: take a photo with the guided camera or upload one from the gallery.
 */
function ImageSourceSelector({ cameraAvailable, isPreparing, onCamera, onUpload }) {
  const inputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    // Allows picking the same file again after "Escolher outra".
    event.target.value = "";
    if (file) onUpload(file);
  };

  return (
    <div className={styles.card}>
      <span className={styles.eyebrow}>Foto</span>
      <h3 className={styles.cardTitle}>Escolha como enviar a foto</h3>
      <p className={styles.cardText}>
        Use uma foto da cabeça vista de cima. Nada é salvo: ao sair desta página, a análise é descartada.
      </p>

      <div className={styles.sourceGrid}>
        {cameraAvailable && (
          <button type="button" className={styles.sourceOption} onClick={onCamera} disabled={isPreparing}>
            <span className={styles.sourceIcon}><PhotoCameraOutlinedIcon /></span>
            <span className={styles.sourceLabel}>Tirar foto</span>
            <span className={styles.sourceHint}>Abre a câmera com um guia de enquadramento.</span>
          </button>
        )}

        <button
          type="button"
          className={styles.sourceOption}
          onClick={() => inputRef.current && inputRef.current.click()}
          disabled={isPreparing}
        >
          <span className={styles.sourceIcon}>
            {isPreparing ? <CircularProgress size={24} color="inherit" /> : <FileUploadOutlinedIcon />}
          </span>
          <span className={styles.sourceLabel}>{isPreparing ? "Preparando foto..." : "Enviar foto"}</span>
          <span className={styles.sourceHint}>JPEG, PNG ou WebP, até 12 MB.</span>
        </button>

        <input
          ref={inputRef}
          type="file"
          accept={ACCEPTED_IMAGE_TYPES.join(",")}
          className={styles.hiddenInput}
          onChange={handleFileChange}
        />
      </div>

      <ul className={styles.instructions}>
        {INSTRUCTIONS.map((text) => (
          <li key={text}>
            <CheckIcon fontSize="small" className={styles.instructionIcon} />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ImageSourceSelector;
